





























































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import UiSelectStatus from '@/components/UI/select-status.vue';
import * as serviceDoctor from '@/services/doctors';
import * as servicePatient from '@/services/patients';
import * as servicePrescription from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import * as PRESCRIPTION_STATUS from '@/settings/consts/prescription-status';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getServerISODate } from '../../../helpers/dateFormat';


@Component({
  components: {
    UiAutocompleClientsSubsidiaries,
    UiDatePicker,
    UiSelectStatus,
    UiSelectDoctor,
    UiDatePickerRange,
    UiAutocomplePatients
  },
})
export default class PrescriptionListFilters extends BaseComponent {  
  @Prop(Boolean)
  public hideStatus?: boolean;  

  @Prop(Boolean)
  public menuMode?: boolean;

  @Prop()
  public idPrescription: string;

  public doctorLoading: boolean = false;
  public patientLoading: boolean = false;
  public doctors: any = [];
  public patients: any = [];

  public multiOptions = [
    {id: null, label: "Todos"}, 
    {id: false, label: "Comum"}, 
    {id: true, label: "Multicompartimentada"}
  ];

  public search: any = {
    patientId: null,
    doctorId: null,
    idPrescription: null,
    idPrescriptionOld: null,
    hospitalUnit: null,    
    productionDateDone: true,
    productionDate: [null, null],
    prescriptionDateDone: true,
    prescriptionDate: [null, null],
    prescriptionCreatedDate: [null, null],
    multi: null,
    descending: false,
    sortBy: null,
    prescriptionStatus: [
      PRESCRIPTION_STATUS.WAITING_CLIENT.key,
      PRESCRIPTION_STATUS.WAITING_EMEDE.key,
      PRESCRIPTION_STATUS.LOCKED.key,
      PRESCRIPTION_STATUS.WAITING_PHARMACEUTICAL_APPROVE.key,
      PRESCRIPTION_STATUS.ERROR_ON_SEND_TO_PRODUCTION.key,
      PRESCRIPTION_STATUS.SCHEDULED_PRODUCTION.key,
      PRESCRIPTION_STATUS.SENDING_TO_PRODUCTION.key,
      PRESCRIPTION_STATUS.SENT_TO_PRODUCTION.key,
      PRESCRIPTION_STATUS.SENT_PARTIAL_TO_PRODUCTION.key,
    ],
  };

  public expand = 0;

  showProductionDate = false;

  statusList = [];
  statusLoading = false;

  @Watch('search.hospitalUnit')
  public onChangeHospitalUnit(): void {
    this.search.doctorId = null;
    if (!this.isEmede()) {
      this.getPatient();
      this.getDoctors();
    }
  }
  
  @Watch('idPrescription')
  public onChangeIdPrescription(): void {
      if(this.idPrescription){
        this.search =  {
          ...this.search,
          idPrescription: this.idPrescription,
          prescriptionDate: null,
        };        
      }else{
        this.search =  {
          ...this.search,
          idPrescription: null,
          prescriptionDate: getServerISODate(),
        };   
      }

      this.onChangeSearch();
  }

  public onChangeSearch() {
    if (this.menuMode) {
      return;
    }
    this.emitFilter();
  }

  public onBtnFilterClick() {    
    this.emitFilter();
  }

  public emitFilter() {
    if (this.menuMode) {
      this.search.descending = this.descending;
      this.search.sortBy = this.sortBy;
    } else {
      this.search.descending = false;
      this.search.sortBy = null;
    }
    this.search.idPrescriptionOld = this.search.idPrescription;
    setTimeout(() => {
      this.$emit('filter', this.search);
    }, 300);
  }

  public onChangeStatus(listaStatus) {
      this.search.prescriptionStatus = listaStatus;
      this.onChangeSearch();
  }

  public beforeMount() {
    this.loadStatus();
    this.load();
  }

  loadStatus() {
    this.statusList = [];
    this.statusLoading = true;
    servicePrescription.listStatus().subscribe(res => {
      this.statusLoading = false;
      res.forEach(sRes => {
        let item = PRESCRIPTION_STATUS.STATUS_PRESCRIPTION_LIST.find(sp => sp.key == sRes)
        if (item) {
          this.statusList.push(item);
        }
      });
    }, (error) => {
      this.statusLoading = false;
      this.showToastApiError(error);
    })
  }

  public mounted() {
    getLocalUser().subscribe(l => {
      if (this.isEmede()) {
        this.search.productionDate = [getServerISODate(), getServerISODate()];
        this.search.prescriptionDate = [null, null];
        this.showProductionDate = true;
      } else {
        this.search.productionDate = [null, null];
        this.search.prescriptionDate = [getServerISODate(), getServerISODate()];
        this.showProductionDate = false;
      }
      this.$emit('filter', this.search);
    });
  }

  public showDoctorFilter(): boolean {
    return !this.isDoctor();
  }

  public load() {
    this.getPatient();
    this.getDoctors();

    if (this.isDoctor()) {
      getLocalUser().subscribe((currentUser) => {
        this.search.doctorId = currentUser.id;
      });
      this.onChangeSearch();
    }
  }

  public getPatient(): void {
    this.search.patient = null;
    this.patients = [];

    let getPatients;
    if (!!this.search.hospitalUnit && !!this.search.hospitalUnit.id) {
      getPatients = servicePatient.getPatientsCombo(null, [this.search.hospitalUnit.id], null);
    } else {
      getPatients = servicePatient.getPatientsCombo();
    }
    

    if (!!getPatients) {
      this.patientLoading = true;
      getPatients.subscribe((r) => {
        this.patientLoading = false;
        this.patients = r.map((item) => {
          return {
            ...item,
            setor: item.setor || '',
            leito: item.leito || '',
            same: item.same || '',
            termo: item.termo || null,
          };
        });
      });
    }
  }

  public getDoctors(): void {
    this.search.doctor = null;
    this.doctors = [];

    let getDoctors;
    if (this.isEmede()) {
      getDoctors = serviceDoctor.getLeanDoctors();
    } else if (!!this.search.hospitalUnit && !!this.search.hospitalUnit.id) {
      getDoctors = serviceDoctor.getClientDoctors(this.search.hospitalUnit.id);
    }

    if (!!getDoctors) {
      this.doctorLoading = true;
      getDoctors.subscribe((r) => {
        this.doctors = r;
        this.doctorLoading = false;
      });
    }
  }

  descending = false;
  sortBy = 'dataPrescricao';
  sortOptions = [];

  buildSortOptions() {
    this.descending = false;
    this.sortBy = 'dataPrescricao';
    this.sortOptions = [];
    if (this.showProductionDate) {
      this.sortOptions.push({text : "Data de Produção", value: "dataProducao"});
    }

    this.sortOptions.push({text : "Data de Entrega", value: "dataPrescricao"});
    this.sortOptions.push({text : "Data de Criação", value: "dataCriacao"});

    this.sortOptions.push({text : "Unidade", value: "unidade.nome"});
    this.sortOptions.push({text : "Médico", value: "medico.nome"});
    this.sortOptions.push({text : "Paciente", value: "paciente.nome"});

    if (!this.hideStatus) {
      this.sortOptions.push({text : "Status", value: "statusPrescricao"});
    }
  }

  @Watch('hideStatus', {immediate: true})
  @Watch('showProductionDate', {immediate: true}) 
  onShowHideChange() {
    this.buildSortOptions();
  }

  sortAscDescChange() {
    this.descending = !this.descending;
  }
}
